const AlkyMationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 128 128"
    role="img"
    aria-label="AlkyMation icon"
  >
    <path
      d="M16 66 C38 40, 74 40, 96 66"
      fill="none"
      stroke="currentColor"
      strokeWidth="8"
      strokeLinecap="round"
    />
    <path d="M100 66 L92 60 L92 72 Z" fill="#52c41a" transform="translate(-4,0)" />
    <circle cx="16" cy="66" r="8" fill="#52c41a" stroke="#f0f0f0" strokeWidth="2" />
    <circle cx="56" cy="66" r="11" fill="#ffffff" stroke="currentColor" strokeWidth="4" />
    <circle cx="96" cy="66" r="8" fill="#ff7875" stroke="#f0f0f0" strokeWidth="2" />
  </svg>
);

export default AlkyMationIcon;
